
export default {
  props: {
    variant: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'pill', 'full'].includes(value)
      },
    },
    arrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classObject() {
      return {
        'rounded-full w-60 h-8 px-7 ': this.variant === 'pill',
        'w-full': this.variant === 'full',
      }
    },
  },
}
